<div
  [ngClass]="
    withLeftDivider() ? 'border-start h-100 d-flex align-items-center ps-2' : ''
  "
>
  <a
    [href]="url()"
    class="logo"
    [attr.aria-label]="label()"
    [target]="target()"
  >
    <img [src]="src()" alt="" />
  </a>
</div>
